
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.988 1c3.82 0 6.989 3.253 7.012 7.246 0 2.415-1.165 4.519-2.795 5.738v1.794c0 .502-.42.909-.91.956l-6.404.527h-.094a.94.94 0 0 1-.652-.263c-.187-.167-.35-.43-.35-.693V13.96C5.932 12.646 5 10.685 5 8.246 5 4.253 8.168 1 11.988 1m0 1.913c-2.818 0-5.125 2.392-5.101 5.333 0 1.96.745 3.395 2.352 4.352a.99.99 0 0 1 .42.837v1.841l4.658-.382v-1.46c0-.334.163-.669.466-.836 1.468-.813 2.307-2.44 2.33-4.352 0-2.941-2.306-5.333-5.125-5.333m3.238 16.883-6.36.478h-.07c-.488 0-.884-.383-.93-.885a.954.954 0 0 1 .861-1.028l6.36-.478a.92.92 0 0 1 1.001.884.954.954 0 0 1-.862 1.029M13.2 22.809l-2.283.19h-.07c-.49 0-.885-.382-.932-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .979.884.953.953 0 0 1-.862 1.029",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.692 8.222c-.046.43-.396.765-.815.765h-.07a.825.825 0 0 1-.722-.909c.14-1.363-1.025-1.865-1.165-1.913a.87.87 0 0 1-.489-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.236 3.635",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M11.988 1c3.82 0 6.989 3.253 7.012 7.246 0 2.415-1.165 4.519-2.795 5.738v1.794c0 .502-.42.909-.91.956l-6.404.527h-.094a.94.94 0 0 1-.652-.263c-.187-.167-.35-.43-.35-.693V13.96C5.932 12.646 5 10.685 5 8.246 5 4.253 8.168 1 11.988 1m0 1.913c-2.818 0-5.125 2.392-5.101 5.333 0 1.96.745 3.395 2.352 4.352a.99.99 0 0 1 .42.837v1.841l4.658-.382v-1.46c0-.334.163-.669.466-.836 1.468-.813 2.307-2.44 2.33-4.352 0-2.941-2.306-5.333-5.125-5.333m3.238 16.883-6.36.478h-.07c-.488 0-.884-.383-.93-.885a.954.954 0 0 1 .861-1.028l6.36-.478a.92.92 0 0 1 1.001.884.954.954 0 0 1-.862 1.029M13.2 22.809l-2.283.19h-.07c-.49 0-.885-.382-.932-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .979.884.953.953 0 0 1-.862 1.029\" fill=\"#000\"/><path d=\"M15.692 8.222c-.046.43-.396.765-.815.765h-.07a.825.825 0 0 1-.722-.909c.14-1.363-1.025-1.865-1.165-1.913a.87.87 0 0 1-.489-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.236 3.635\" fill=\"#000\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light.31442d8e73b5915b3fcfb9fb2f64ebc2.svg"),
        {
          React: SvgLight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      